import React from 'react'

const CourseTabError = (): JSX.Element => {
  return (
    <div data-testid='course-tab-error-content'>
      <div>There was an error retrieving Course Data. Please try again.</div>
    </div>
  )
}

export default CourseTabError
